import { defineMessages } from 'react-intl';

import { CashCryptoToggle } from '#src/components/settings/CashCryptoToggle/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useUpdateCurrency } from '#src/hooks/useUpdateCurrency.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Currency of in-app purchase items',
  },
});

export const Currency = () => {
  const { currency } = useCurrentUserContext();
  const { updateCurrency } = useUpdateCurrency();

  return (
    <CashCryptoToggle
      title={messages.title}
      name="currency"
      value={currency}
      onUpdate={value => updateCurrency('currency')(value)}
    />
  );
};
